/**
 * page-title-version — pure auto-version bump for html.init page titles.
 *
 * When the agent builds a page whose exact title already exists in the
 * workspace, the title is bumped to the next "Base (style) vN".
 *
 * Pinned by apps/web/src/features/chat/hooks/useChat.ui-directive-char.test.ts.
 */

// base + optional "(style)" + "vN"
const NAME_RE = /^(.+?)(?:\s*\((.+?)\))?\s*v(\d+)$/

/**
 * Given an incoming page title and the list of titles that already exist in the
 * workspace, return the (possibly version-bumped) title. Returns the input
 * unchanged when no exact-title collision exists.
 */
export function bumpPageTitleVersion(htmlTitle: string, existingTitles: string[]): string {
  const match = NAME_RE.exec(htmlTitle)
  if (!(match || htmlTitle)) return htmlTitle
  if (!existingTitles.includes(htmlTitle)) return htmlTitle

  const baseMatch = NAME_RE.exec(htmlTitle)
  const base = baseMatch ? baseMatch[1].trim() : htmlTitle.replace(/\s*v\d+$/, '').trim()
  const style = baseMatch ? baseMatch[2] || '' : ''
  const prefix = style ? `${base} (${style})` : base

  let maxV = 0
  for (const t of existingTitles) {
    const m2 = NAME_RE.exec(t)
    if (m2) {
      const existBase = m2[1].trim()
      const existStyle = m2[2] || ''
      const existPrefix = existStyle ? `${existBase} (${existStyle})` : existBase
      if (existPrefix === prefix) maxV = Math.max(maxV, parseInt(m2[3], 10))
    }
  }
  return `${prefix} v${maxV + 1}`
}
